import { FC, useState, useEffect, Fragment } from 'react'

import { Modal } from 'react-bootstrap'

// type Props = {
//   showAlertUpdateModal: boolean
//   handleShowUpdateProfileModal: any
// }

const AlertUpdateProfileContent = ({
  showAlertUpdateModal,
  handleShowUpdateProfileModal,
  email
}) => {
  const [showModal, setShowModal] = useState(false)

  useEffect(() => {
    setShowModal(showAlertUpdateModal)
  }, [showAlertUpdateModal])

  const handleCloseModal = () => {
    setShowModal(false)
    handleShowUpdateProfileModal(false)
  }

  return (
    <Modal show={showModal} centered size='sm'>
      <div className='p-5'>
        {/* <img
          src={require('../../assets/img/update-profile-image.png')}
          alt='PANA'
          style={{ height: 'auto', width: '100%' }}
        /> */}

        <div className='text-center'>
          <p>Versi lengkap tesis/disertasi tersedia.</p>
          <p>Hubungi <span className='fw-bold'>{email}</span> untuk informasi lebih lanjut.</p>
        </div>

        <div className='d-flex justify-content-end'>
          <button className='btn btn-secondary btn-sm mx-3 mt-8 w-100' onClick={handleCloseModal}>
            Tutup
          </button>
        </div>

      </div>
    </Modal>
  )
}

const AlertUpdateProfileModal = ({
  showAlertUpdateModal,
  handleShowUpdateProfileModal,
  email
}) => {
  return (
    <AlertUpdateProfileContent
      showAlertUpdateModal={showAlertUpdateModal}
      handleShowUpdateProfileModal={handleShowUpdateProfileModal}
      email={email}
    />
  )
}

export default AlertUpdateProfileModal
